import { createContext, useContext, useState } from 'react';

const UserDroitsContext = createContext<any>({
    loadingDroits: false,
    setLoadingDroits: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function UserDroitsProvider({ children }: Props) {
    const [loadingDroits, setLoadingDroits] = useState(false);

    return (
        <UserDroitsContext.Provider
            value={{
                loadingDroits,
                setLoadingDroits,
            }}
        >
            {children}
        </UserDroitsContext.Provider>
    );
}

export const useUserDroitsContext = () => useContext(UserDroitsContext);
